module.exports = __webpack_public_path__ + "static/img/glove_anis.6fad044.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_anis.png
// module id = VSR+
// module chunks = 0